import { DateTimeV2 } from '../../../value-object/DateTimeV2'

export type VersionReportVersionEntity = {
  uuid: string
  lockVersion: number
  snapshotUuid: string
  templateUuid: string
  templateName: string
  name: string
  pages: VersionReportVersionPageEntity[]
  createdAt: DateTimeV2
  createdBy: {
    uuid: string
    name: string
  }
  updatedAt: DateTimeV2
  updatedBy: {
    uuid: string
    name: string
  }
  takenAt: DateTimeV2
  discussionThreadCountByTemplatePage?: Record<string, number>
}

export type VersionReportVersionPageEntity = {
  uuid: string
  lockVersion: number
  templatePageUuid: string
  pageTitle: string
  leadSentence: string | undefined
  pageNumber: number
  pageType: VersionReportPageType
  config: VersionReportPageConfig
  rows: VersionReportVersionPageRowEntity[]
}

export type VersionReportVersionPageRowEntity = {
  uuid: string
  lockVersion: number
  targetUuid: string
  displayOrder: number
  status: VersionReportStatus
  comment: string
}

export const sortTargetUuidsByDisplayOrder = (
  rows: VersionReportVersionPageRowEntity[]
): string[] =>
  rows
    .slice()
    .sort((a, b) => a.displayOrder - b.displayOrder)
    .map(row => row.targetUuid)

export type VersionReportStatus = 'SUNNY' | 'CLOUDY' | 'RAINY'

export type VersionReportPageType =
  | 'PROGRESS_OVERVIEW'
  | 'PROGRESS_REPORT_BY_PROCESS'
  | 'PROGRESS_REPORT_BY_TEAM'

export type VersionReportPageConfig =
  | ProgressOverviewPageConfig
  | ProgressReportByProcessPageConfig
  | ProgressReportByTeamPageConfig
export type ProgressOverviewPageConfig = {
  type: 'PROGRESS_OVERVIEW'
  tableRows: string[]
}
export type ProgressReportByProcessPageConfig = {
  type: 'PROGRESS_REPORT_BY_PROCESS'
  tableRows: string[]
}
export type ProgressReportByTeamPageConfig = {
  type: 'PROGRESS_REPORT_BY_TEAM'
  rootUuid: string | undefined
  tableRows: string[]
}
